module.exports = __webpack_public_path__ + "d4c4d3e7c3db6c0edd4f1a04df9bf669.svg";